import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';

import {
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

import {
  commandWorkspaceWorkspacesList,
  commandWorkspaceRevokePermission,
} from 'containers/ConnectionManager/actions';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import {
  PageWrapper,
  PageViewport,
  PageActions,
  PageActionsRight,
  PageContent,
} from 'components/PageStyles';

import Modal from 'components/Modal';

import {
  Grid,
  GridCell,
} from 'components/LayoutGrid';

import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import Sidebar from 'Workspace/components/WorkspaceSidebar';
import { selectWorkspacesList } from 'Workspace/Admin/store/selectors';

import gtmService from 'utils/gtm/gtmService';

import workspaceShape from 'Workspace/types/workspace';
import AdminNavigation from '../AdminNavigation';
import WorkspaceCard from './components/WorkspaceCard';
import CreateWorkspaceModal from './components/CreateWorkspaceModal';
import messages from './messages';
import { pageName } from 'utils/gtm/constants';

class WorkspacesPage extends React.Component {
  state = {
    showCreateWorkspaceModal: false,
  }

  componentDidMount() {
    this.props.getWorkspaces();
    gtmService.pushTelemetryPageActivityAndView({ pageName: pageName.WORKSPACE_PAGE });
  }

  getSortedWorkspaces(workspaces) {
    return orderBy(workspaces, (workspace) => workspace.name.replace(/\s/g, '').toLowerCase(), 'asc');
  }

  toggleCreateWorkspaceModal = () => {
    this.setState({
      showCreateWorkspaceModal: !this.state.showCreateWorkspaceModal,
    });
  }

  render() {
    const { showCreateWorkspaceModal } = this.state;
    const { workspacesList, revokePermission } = this.props;
    const sortedWorkspacesList = this.getSortedWorkspaces(workspacesList);

    return (
      <PageWrapper>
        <Sidebar navigation={<AdminNavigation selectedKey={'workspaces'} />} />
        <Modal
          visible={showCreateWorkspaceModal}
          onDismiss={this.toggleCreateWorkspaceModal}
          title={intl.formatMessage(messages.newWorkspaceModal)}
        >
          <CreateWorkspaceModal onDismiss={this.toggleCreateWorkspaceModal} />
        </Modal>
        <PageViewport>
          <WorkspaceHeader title={intl.formatMessage(messages.workspaces)} />
          <PageActions>
            <PageActionsRight>
              <Button primary onClick={this.toggleCreateWorkspaceModal}>
                <MaterialIcon id="add" left />
                {intl.formatMessage(messages.newWorkspace)}
              </Button>
            </PageActionsRight>
          </PageActions>
          <PageContent>
            <Grid>
              {
                workspacesList &&
                sortedWorkspacesList.map((workspace) => (
                  <GridCell key={`${workspace.id}cell`} span={{ desktop: 4, tablet: 6, mobile: 12 }} >
                    <WorkspaceCard
                      key={workspace.id}
                      id={workspace.id}
                      name={workspace.name}
                      onRevoke={(account) => revokePermission(workspace.id, account.id, account.type)}
                    />
                  </GridCell>))
              }
            </Grid>
          </PageContent>
        </PageViewport>
      </PageWrapper>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getWorkspaces: () => dispatch(commandWorkspaceWorkspacesList()),
  revokePermission: (workspaceId, accountId, collaboratorType) => 
    dispatch(commandWorkspaceRevokePermission(workspaceId, accountId, collaboratorType)),
});

const mapStateToProps = (state) => ({
  workspacesList: selectWorkspacesList(state),
});

WorkspacesPage.propTypes = {
  getWorkspaces: PropTypes.func,
  revokePermission: PropTypes.func,
  workspacesList: PropTypes.arrayOf(workspaceShape),
  location: PropTypes.object,
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkspacesPage);
